<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'LanguageComponent.vue'
}
</script>

<style scoped></style>
